// src/features/system/tenants/hooks/useTenants.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchTenants, createTenant, type Tenant, type TenantCreateIn } from '../api/tenantsApi';

export function useTenants() {
  const qc = useQueryClient();

  const list = useQuery<Tenant[], Error>({
    queryKey : ['tenants'],
    queryFn  : fetchTenants,
    staleTime: 60_000,
  });

  const create = useMutation({ 
    mutationFn: (p: TenantCreateIn) => createTenant(p),
    onSuccess : () => qc.invalidateQueries({ queryKey: ['tenants'] }),
  });

  return { ...list, create };
}